const stats = [
  {
    value: "10+",
    label: "Years of Experience",
    labelAr: "سنوات من الخبرة",
    icon: "ri-award-line",
    color: "#c6a864",
  },
  {
    value: "1k+",
    label: "Clients Served",
    labelAr: "عميلة راضية",
    icon: "ri-heart-line",
    color: "#c6a864",
  },
  {
    value: "15+",
    label: "Services Available",
    labelAr: "خدمة متاحة",
    icon: "ri-scissors-2-line",
    color: "#c6a864",
  },
  {
    platform: "WhatsApp",
    value: "Instant",
    label: "Booking Available",
    labelAr: "حجز فوري",
    icon: "ri-whatsapp-line",
    color: "#25D366",
    isWhatsapp: true,
  },
];

export default function SocialProof() {
  return (
    <section className="bg-white py-10 border-b border-[#ece8e0]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        {/* Arabic welcome tagline */}
        <p
          className="text-center text-[#1a2744] text-xl sm:text-2xl font-bold mb-6"
          style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
        >
          مرحباً بكِ في صالون وسبا القمر الأزرق — الخوض، مسقط
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-12 md:gap-16 mb-4">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col items-center gap-1 text-center">
              <div className="w-10 h-10 flex items-center justify-center mb-1">
                <i className={`${s.icon} text-2xl`} style={{ color: s.color }}></i>
              </div>
              <span
                className="text-[#1a2744] font-bold text-2xl leading-none"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {s.value}
              </span>
              <p className="text-xs text-gray-500 tracking-wide mt-0.5">{s.label}</p>
              <p
                className="text-xs text-gray-400"
                style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
              >
                {s.labelAr}
              </p>
            </div>
          ))}
        </div>

        {/* Address bar */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 mt-4">
          <a
            href="https://maps.google.com/?q=Al+Koudh+7+Mazoon+Street+Muscat+Oman"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-xs text-gray-500 hover:text-[#c6a864] transition-colors cursor-pointer"
          >
            <i className="ri-map-pin-line text-[#4a7fa5]"></i>
            <span>Al Koudh 7, Mazoon Street, Muscat, Oman</span>
          </a>
          <span className="text-xs text-gray-400" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>
            الخوض 7، شارع مزون، مسقط، عمان
          </span>
        </div>
      </div>
    </section>
  );
}
